<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :height="getHeight"
    :viewBox="`0 0 35 35`"
    :width="getWidth"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-299.000000, -133.000000)">
        <g transform="translate(299.000000, 133.000000)">
          <path d="M17.5,0.5 C8.11115925,0.5 0.5,8.11115925 0.5,17.5 C0.5,26.8888407 8.11115925,34.5 17.5,34.5 C26.8888407,34.5 34.5,26.8888407 34.5,17.5 C34.5,8.11115925 26.8888407,0.5 17.5,0.5 Z" id="Rectangle-31-Copy-4" stroke="#DDDDDD" fill="#FFFFFF"></path>
          <g id="x-(3)" transform="translate(13.000000, 13.000000)" stroke="#000000" stroke-linecap="square" stroke-width="2">
            <line x1="9" y1="0" x2="0" y2="9"></line>
            <line x1="0" y1="0" x2="9" y2="9"></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-close-circle'

  export default {
    name: 'SvgIconCloseCircle',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '35',
        type: String
      },
      width: {
        default: '35',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.setNamespace(namespace)
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconCloseCircle.vue